"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               v5.29.3
// source: property/property.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.Property = exports.protobufPackage = void 0;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
const single_address_1 = require("../addresses/single_address");
const integer_range_1 = require("../common/integer_range");
const timestamp_1 = require("../google/protobuf/timestamp");
const bathrooms_1 = require("./bathrooms");
const bedrooms_1 = require("./bedrooms");
const brokerage_1 = require("./brokerage");
const buyer_agent_1 = require("./buyer_agent");
const display_1 = require("./display");
const features_1 = require("./features");
const fee_1 = require("./fee");
const listing_agent_1 = require("./listing_agent");
const listing_type_1 = require("./listing_type");
const media_1 = require("./media");
const open_house_1 = require("./open_house");
const parking_1 = require("./parking");
const price_1 = require("./price");
const provider_1 = require("./provider");
const rooms_1 = require("./rooms");
const sold_1 = require("./sold");
const status_1 = require("./status");
const tag_1 = require("./tag");
const tax_1 = require("./tax");
const type_1 = require("./type");
const virtual_tour_1 = require("./virtual_tour");
const year_built_1 = require("./year_built");
exports.protobufPackage = "property";
function createBaseProperty() {
    return {
        id: 0,
        mls: "",
        docId: "",
        listingKey: "",
        slug: "",
        status: undefined,
        listingType: 0,
        type: undefined,
        fullAddress: "",
        unprocessedFullAddress: "",
        addresses: [],
        display: undefined,
        postalCode: "",
        position: "",
        squareFootage: undefined,
        bathrooms: undefined,
        bedrooms: undefined,
        rooms: [],
        features: undefined,
        parking: undefined,
        yearBuilt: undefined,
        media: [],
        fees: [],
        tax: undefined,
        openHouse: [],
        price: undefined,
        brokerage: undefined,
        listingAgent: undefined,
        sold: undefined,
        buyerAgent: undefined,
        virtualTour: undefined,
        createdAt: undefined,
        updatedOn: undefined,
        expiredAt: undefined,
        soldAt: undefined,
        providerId: 0,
        description: "",
        tags: [],
    };
}
exports.Property = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.id !== 0) {
            writer.uint32(8).uint64(message.id);
        }
        if (message.mls !== "") {
            writer.uint32(18).string(message.mls);
        }
        if (message.docId !== "") {
            writer.uint32(26).string(message.docId);
        }
        if (message.listingKey !== "") {
            writer.uint32(34).string(message.listingKey);
        }
        if (message.slug !== "") {
            writer.uint32(42).string(message.slug);
        }
        if (message.status !== undefined) {
            status_1.Status.encode(message.status, writer.uint32(50).fork()).join();
        }
        if (message.listingType !== 0) {
            writer.uint32(56).int32(message.listingType);
        }
        if (message.type !== undefined) {
            type_1.Type.encode(message.type, writer.uint32(66).fork()).join();
        }
        if (message.fullAddress !== "") {
            writer.uint32(74).string(message.fullAddress);
        }
        if (message.unprocessedFullAddress !== "") {
            writer.uint32(82).string(message.unprocessedFullAddress);
        }
        for (const v of message.addresses) {
            single_address_1.SingleAddress.encode(v, writer.uint32(90).fork()).join();
        }
        if (message.display !== undefined) {
            display_1.Display.encode(message.display, writer.uint32(98).fork()).join();
        }
        if (message.postalCode !== "") {
            writer.uint32(106).string(message.postalCode);
        }
        if (message.position !== "") {
            writer.uint32(114).string(message.position);
        }
        if (message.squareFootage !== undefined) {
            integer_range_1.IntegerRange.encode(message.squareFootage, writer.uint32(122).fork()).join();
        }
        if (message.bathrooms !== undefined) {
            bathrooms_1.Bathrooms.encode(message.bathrooms, writer.uint32(130).fork()).join();
        }
        if (message.bedrooms !== undefined) {
            bedrooms_1.Bedrooms.encode(message.bedrooms, writer.uint32(138).fork()).join();
        }
        for (const v of message.rooms) {
            rooms_1.Rooms.encode(v, writer.uint32(146).fork()).join();
        }
        if (message.features !== undefined) {
            features_1.PropertyFeatures.encode(message.features, writer.uint32(154).fork()).join();
        }
        if (message.parking !== undefined) {
            parking_1.Parking.encode(message.parking, writer.uint32(162).fork()).join();
        }
        if (message.yearBuilt !== undefined) {
            year_built_1.YearBuilt.encode(message.yearBuilt, writer.uint32(170).fork()).join();
        }
        for (const v of message.media) {
            media_1.Media.encode(v, writer.uint32(178).fork()).join();
        }
        for (const v of message.fees) {
            fee_1.Fee.encode(v, writer.uint32(186).fork()).join();
        }
        if (message.tax !== undefined) {
            tax_1.Tax.encode(message.tax, writer.uint32(194).fork()).join();
        }
        for (const v of message.openHouse) {
            open_house_1.OpenHouse.encode(v, writer.uint32(202).fork()).join();
        }
        if (message.price !== undefined) {
            price_1.Price.encode(message.price, writer.uint32(210).fork()).join();
        }
        if (message.brokerage !== undefined) {
            brokerage_1.Brokerage.encode(message.brokerage, writer.uint32(218).fork()).join();
        }
        if (message.listingAgent !== undefined) {
            listing_agent_1.ListingAgent.encode(message.listingAgent, writer.uint32(226).fork()).join();
        }
        if (message.sold !== undefined) {
            sold_1.Sold.encode(message.sold, writer.uint32(234).fork()).join();
        }
        if (message.buyerAgent !== undefined) {
            buyer_agent_1.BuyerAgent.encode(message.buyerAgent, writer.uint32(242).fork()).join();
        }
        if (message.virtualTour !== undefined) {
            virtual_tour_1.VirtualTour.encode(message.virtualTour, writer.uint32(250).fork()).join();
        }
        if (message.createdAt !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(258).fork()).join();
        }
        if (message.updatedOn !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.updatedOn), writer.uint32(266).fork()).join();
        }
        if (message.expiredAt !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.expiredAt), writer.uint32(274).fork()).join();
        }
        if (message.soldAt !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.soldAt), writer.uint32(282).fork()).join();
        }
        if (message.providerId !== 0) {
            writer.uint32(288).int32(message.providerId);
        }
        if (message.description !== "") {
            writer.uint32(298).string(message.description);
        }
        for (const v of message.tags) {
            tag_1.Tag.encode(v, writer.uint32(306).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProperty();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.id = longToNumber(reader.uint64());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.mls = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.docId = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.listingKey = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.slug = reader.string();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.status = status_1.Status.decode(reader, reader.uint32());
                    continue;
                }
                case 7: {
                    if (tag !== 56) {
                        break;
                    }
                    message.listingType = reader.int32();
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.type = type_1.Type.decode(reader, reader.uint32());
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.fullAddress = reader.string();
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.unprocessedFullAddress = reader.string();
                    continue;
                }
                case 11: {
                    if (tag !== 90) {
                        break;
                    }
                    message.addresses.push(single_address_1.SingleAddress.decode(reader, reader.uint32()));
                    continue;
                }
                case 12: {
                    if (tag !== 98) {
                        break;
                    }
                    message.display = display_1.Display.decode(reader, reader.uint32());
                    continue;
                }
                case 13: {
                    if (tag !== 106) {
                        break;
                    }
                    message.postalCode = reader.string();
                    continue;
                }
                case 14: {
                    if (tag !== 114) {
                        break;
                    }
                    message.position = reader.string();
                    continue;
                }
                case 15: {
                    if (tag !== 122) {
                        break;
                    }
                    message.squareFootage = integer_range_1.IntegerRange.decode(reader, reader.uint32());
                    continue;
                }
                case 16: {
                    if (tag !== 130) {
                        break;
                    }
                    message.bathrooms = bathrooms_1.Bathrooms.decode(reader, reader.uint32());
                    continue;
                }
                case 17: {
                    if (tag !== 138) {
                        break;
                    }
                    message.bedrooms = bedrooms_1.Bedrooms.decode(reader, reader.uint32());
                    continue;
                }
                case 18: {
                    if (tag !== 146) {
                        break;
                    }
                    message.rooms.push(rooms_1.Rooms.decode(reader, reader.uint32()));
                    continue;
                }
                case 19: {
                    if (tag !== 154) {
                        break;
                    }
                    message.features = features_1.PropertyFeatures.decode(reader, reader.uint32());
                    continue;
                }
                case 20: {
                    if (tag !== 162) {
                        break;
                    }
                    message.parking = parking_1.Parking.decode(reader, reader.uint32());
                    continue;
                }
                case 21: {
                    if (tag !== 170) {
                        break;
                    }
                    message.yearBuilt = year_built_1.YearBuilt.decode(reader, reader.uint32());
                    continue;
                }
                case 22: {
                    if (tag !== 178) {
                        break;
                    }
                    message.media.push(media_1.Media.decode(reader, reader.uint32()));
                    continue;
                }
                case 23: {
                    if (tag !== 186) {
                        break;
                    }
                    message.fees.push(fee_1.Fee.decode(reader, reader.uint32()));
                    continue;
                }
                case 24: {
                    if (tag !== 194) {
                        break;
                    }
                    message.tax = tax_1.Tax.decode(reader, reader.uint32());
                    continue;
                }
                case 25: {
                    if (tag !== 202) {
                        break;
                    }
                    message.openHouse.push(open_house_1.OpenHouse.decode(reader, reader.uint32()));
                    continue;
                }
                case 26: {
                    if (tag !== 210) {
                        break;
                    }
                    message.price = price_1.Price.decode(reader, reader.uint32());
                    continue;
                }
                case 27: {
                    if (tag !== 218) {
                        break;
                    }
                    message.brokerage = brokerage_1.Brokerage.decode(reader, reader.uint32());
                    continue;
                }
                case 28: {
                    if (tag !== 226) {
                        break;
                    }
                    message.listingAgent = listing_agent_1.ListingAgent.decode(reader, reader.uint32());
                    continue;
                }
                case 29: {
                    if (tag !== 234) {
                        break;
                    }
                    message.sold = sold_1.Sold.decode(reader, reader.uint32());
                    continue;
                }
                case 30: {
                    if (tag !== 242) {
                        break;
                    }
                    message.buyerAgent = buyer_agent_1.BuyerAgent.decode(reader, reader.uint32());
                    continue;
                }
                case 31: {
                    if (tag !== 250) {
                        break;
                    }
                    message.virtualTour = virtual_tour_1.VirtualTour.decode(reader, reader.uint32());
                    continue;
                }
                case 32: {
                    if (tag !== 258) {
                        break;
                    }
                    message.createdAt = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 33: {
                    if (tag !== 266) {
                        break;
                    }
                    message.updatedOn = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 34: {
                    if (tag !== 274) {
                        break;
                    }
                    message.expiredAt = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 35: {
                    if (tag !== 282) {
                        break;
                    }
                    message.soldAt = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 36: {
                    if (tag !== 288) {
                        break;
                    }
                    message.providerId = reader.int32();
                    continue;
                }
                case 37: {
                    if (tag !== 298) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
                }
                case 38: {
                    if (tag !== 306) {
                        break;
                    }
                    message.tags.push(tag_1.Tag.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.Number(object.id) : 0,
            mls: isSet(object.mls) ? globalThis.String(object.mls) : "",
            docId: isSet(object.docId) ? globalThis.String(object.docId) : "",
            listingKey: isSet(object.listingKey) ? globalThis.String(object.listingKey) : "",
            slug: isSet(object.slug) ? globalThis.String(object.slug) : "",
            status: isSet(object.status) ? status_1.Status.fromJSON(object.status) : undefined,
            listingType: isSet(object.listingType) ? (0, listing_type_1.listingTypeFromJSON)(object.listingType) : 0,
            type: isSet(object.type) ? type_1.Type.fromJSON(object.type) : undefined,
            fullAddress: isSet(object.fullAddress) ? globalThis.String(object.fullAddress) : "",
            unprocessedFullAddress: isSet(object.unprocessedFullAddress)
                ? globalThis.String(object.unprocessedFullAddress)
                : "",
            addresses: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.addresses)
                ? object.addresses.map((e) => single_address_1.SingleAddress.fromJSON(e))
                : [],
            display: isSet(object.display) ? display_1.Display.fromJSON(object.display) : undefined,
            postalCode: isSet(object.postalCode) ? globalThis.String(object.postalCode) : "",
            position: isSet(object.position) ? globalThis.String(object.position) : "",
            squareFootage: isSet(object.squareFootage) ? integer_range_1.IntegerRange.fromJSON(object.squareFootage) : undefined,
            bathrooms: isSet(object.bathrooms) ? bathrooms_1.Bathrooms.fromJSON(object.bathrooms) : undefined,
            bedrooms: isSet(object.bedrooms) ? bedrooms_1.Bedrooms.fromJSON(object.bedrooms) : undefined,
            rooms: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.rooms) ? object.rooms.map((e) => rooms_1.Rooms.fromJSON(e)) : [],
            features: isSet(object.features) ? features_1.PropertyFeatures.fromJSON(object.features) : undefined,
            parking: isSet(object.parking) ? parking_1.Parking.fromJSON(object.parking) : undefined,
            yearBuilt: isSet(object.yearBuilt) ? year_built_1.YearBuilt.fromJSON(object.yearBuilt) : undefined,
            media: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.media) ? object.media.map((e) => media_1.Media.fromJSON(e)) : [],
            fees: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.fees) ? object.fees.map((e) => fee_1.Fee.fromJSON(e)) : [],
            tax: isSet(object.tax) ? tax_1.Tax.fromJSON(object.tax) : undefined,
            openHouse: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.openHouse)
                ? object.openHouse.map((e) => open_house_1.OpenHouse.fromJSON(e))
                : [],
            price: isSet(object.price) ? price_1.Price.fromJSON(object.price) : undefined,
            brokerage: isSet(object.brokerage) ? brokerage_1.Brokerage.fromJSON(object.brokerage) : undefined,
            listingAgent: isSet(object.listingAgent) ? listing_agent_1.ListingAgent.fromJSON(object.listingAgent) : undefined,
            sold: isSet(object.sold) ? sold_1.Sold.fromJSON(object.sold) : undefined,
            buyerAgent: isSet(object.buyerAgent) ? buyer_agent_1.BuyerAgent.fromJSON(object.buyerAgent) : undefined,
            virtualTour: isSet(object.virtualTour) ? virtual_tour_1.VirtualTour.fromJSON(object.virtualTour) : undefined,
            createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : undefined,
            updatedOn: isSet(object.updatedOn) ? fromJsonTimestamp(object.updatedOn) : undefined,
            expiredAt: isSet(object.expiredAt) ? fromJsonTimestamp(object.expiredAt) : undefined,
            soldAt: isSet(object.soldAt) ? fromJsonTimestamp(object.soldAt) : undefined,
            providerId: isSet(object.providerId) ? (0, provider_1.providerFromJSON)(object.providerId) : 0,
            description: isSet(object.description) ? globalThis.String(object.description) : "",
            tags: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.tags) ? object.tags.map((e) => tag_1.Tag.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        var _a, _b, _c, _d, _e, _f;
        const obj = {};
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        if (message.mls !== "") {
            obj.mls = message.mls;
        }
        if (message.docId !== "") {
            obj.docId = message.docId;
        }
        if (message.listingKey !== "") {
            obj.listingKey = message.listingKey;
        }
        if (message.slug !== "") {
            obj.slug = message.slug;
        }
        if (message.status !== undefined) {
            obj.status = status_1.Status.toJSON(message.status);
        }
        if (message.listingType !== 0) {
            obj.listingType = (0, listing_type_1.listingTypeToJSON)(message.listingType);
        }
        if (message.type !== undefined) {
            obj.type = type_1.Type.toJSON(message.type);
        }
        if (message.fullAddress !== "") {
            obj.fullAddress = message.fullAddress;
        }
        if (message.unprocessedFullAddress !== "") {
            obj.unprocessedFullAddress = message.unprocessedFullAddress;
        }
        if ((_a = message.addresses) === null || _a === void 0 ? void 0 : _a.length) {
            obj.addresses = message.addresses.map((e) => single_address_1.SingleAddress.toJSON(e));
        }
        if (message.display !== undefined) {
            obj.display = display_1.Display.toJSON(message.display);
        }
        if (message.postalCode !== "") {
            obj.postalCode = message.postalCode;
        }
        if (message.position !== "") {
            obj.position = message.position;
        }
        if (message.squareFootage !== undefined) {
            obj.squareFootage = integer_range_1.IntegerRange.toJSON(message.squareFootage);
        }
        if (message.bathrooms !== undefined) {
            obj.bathrooms = bathrooms_1.Bathrooms.toJSON(message.bathrooms);
        }
        if (message.bedrooms !== undefined) {
            obj.bedrooms = bedrooms_1.Bedrooms.toJSON(message.bedrooms);
        }
        if ((_b = message.rooms) === null || _b === void 0 ? void 0 : _b.length) {
            obj.rooms = message.rooms.map((e) => rooms_1.Rooms.toJSON(e));
        }
        if (message.features !== undefined) {
            obj.features = features_1.PropertyFeatures.toJSON(message.features);
        }
        if (message.parking !== undefined) {
            obj.parking = parking_1.Parking.toJSON(message.parking);
        }
        if (message.yearBuilt !== undefined) {
            obj.yearBuilt = year_built_1.YearBuilt.toJSON(message.yearBuilt);
        }
        if ((_c = message.media) === null || _c === void 0 ? void 0 : _c.length) {
            obj.media = message.media.map((e) => media_1.Media.toJSON(e));
        }
        if ((_d = message.fees) === null || _d === void 0 ? void 0 : _d.length) {
            obj.fees = message.fees.map((e) => fee_1.Fee.toJSON(e));
        }
        if (message.tax !== undefined) {
            obj.tax = tax_1.Tax.toJSON(message.tax);
        }
        if ((_e = message.openHouse) === null || _e === void 0 ? void 0 : _e.length) {
            obj.openHouse = message.openHouse.map((e) => open_house_1.OpenHouse.toJSON(e));
        }
        if (message.price !== undefined) {
            obj.price = price_1.Price.toJSON(message.price);
        }
        if (message.brokerage !== undefined) {
            obj.brokerage = brokerage_1.Brokerage.toJSON(message.brokerage);
        }
        if (message.listingAgent !== undefined) {
            obj.listingAgent = listing_agent_1.ListingAgent.toJSON(message.listingAgent);
        }
        if (message.sold !== undefined) {
            obj.sold = sold_1.Sold.toJSON(message.sold);
        }
        if (message.buyerAgent !== undefined) {
            obj.buyerAgent = buyer_agent_1.BuyerAgent.toJSON(message.buyerAgent);
        }
        if (message.virtualTour !== undefined) {
            obj.virtualTour = virtual_tour_1.VirtualTour.toJSON(message.virtualTour);
        }
        if (message.createdAt !== undefined) {
            obj.createdAt = message.createdAt.toISOString();
        }
        if (message.updatedOn !== undefined) {
            obj.updatedOn = message.updatedOn.toISOString();
        }
        if (message.expiredAt !== undefined) {
            obj.expiredAt = message.expiredAt.toISOString();
        }
        if (message.soldAt !== undefined) {
            obj.soldAt = message.soldAt.toISOString();
        }
        if (message.providerId !== 0) {
            obj.providerId = (0, provider_1.providerToJSON)(message.providerId);
        }
        if (message.description !== "") {
            obj.description = message.description;
        }
        if ((_f = message.tags) === null || _f === void 0 ? void 0 : _f.length) {
            obj.tags = message.tags.map((e) => tag_1.Tag.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.Property.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        const message = createBaseProperty();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : 0;
        message.mls = (_b = object.mls) !== null && _b !== void 0 ? _b : "";
        message.docId = (_c = object.docId) !== null && _c !== void 0 ? _c : "";
        message.listingKey = (_d = object.listingKey) !== null && _d !== void 0 ? _d : "";
        message.slug = (_e = object.slug) !== null && _e !== void 0 ? _e : "";
        message.status = (object.status !== undefined && object.status !== null)
            ? status_1.Status.fromPartial(object.status)
            : undefined;
        message.listingType = (_f = object.listingType) !== null && _f !== void 0 ? _f : 0;
        message.type = (object.type !== undefined && object.type !== null) ? type_1.Type.fromPartial(object.type) : undefined;
        message.fullAddress = (_g = object.fullAddress) !== null && _g !== void 0 ? _g : "";
        message.unprocessedFullAddress = (_h = object.unprocessedFullAddress) !== null && _h !== void 0 ? _h : "";
        message.addresses = ((_j = object.addresses) === null || _j === void 0 ? void 0 : _j.map((e) => single_address_1.SingleAddress.fromPartial(e))) || [];
        message.display = (object.display !== undefined && object.display !== null)
            ? display_1.Display.fromPartial(object.display)
            : undefined;
        message.postalCode = (_k = object.postalCode) !== null && _k !== void 0 ? _k : "";
        message.position = (_l = object.position) !== null && _l !== void 0 ? _l : "";
        message.squareFootage = (object.squareFootage !== undefined && object.squareFootage !== null)
            ? integer_range_1.IntegerRange.fromPartial(object.squareFootage)
            : undefined;
        message.bathrooms = (object.bathrooms !== undefined && object.bathrooms !== null)
            ? bathrooms_1.Bathrooms.fromPartial(object.bathrooms)
            : undefined;
        message.bedrooms = (object.bedrooms !== undefined && object.bedrooms !== null)
            ? bedrooms_1.Bedrooms.fromPartial(object.bedrooms)
            : undefined;
        message.rooms = ((_m = object.rooms) === null || _m === void 0 ? void 0 : _m.map((e) => rooms_1.Rooms.fromPartial(e))) || [];
        message.features = (object.features !== undefined && object.features !== null)
            ? features_1.PropertyFeatures.fromPartial(object.features)
            : undefined;
        message.parking = (object.parking !== undefined && object.parking !== null)
            ? parking_1.Parking.fromPartial(object.parking)
            : undefined;
        message.yearBuilt = (object.yearBuilt !== undefined && object.yearBuilt !== null)
            ? year_built_1.YearBuilt.fromPartial(object.yearBuilt)
            : undefined;
        message.media = ((_o = object.media) === null || _o === void 0 ? void 0 : _o.map((e) => media_1.Media.fromPartial(e))) || [];
        message.fees = ((_p = object.fees) === null || _p === void 0 ? void 0 : _p.map((e) => fee_1.Fee.fromPartial(e))) || [];
        message.tax = (object.tax !== undefined && object.tax !== null) ? tax_1.Tax.fromPartial(object.tax) : undefined;
        message.openHouse = ((_q = object.openHouse) === null || _q === void 0 ? void 0 : _q.map((e) => open_house_1.OpenHouse.fromPartial(e))) || [];
        message.price = (object.price !== undefined && object.price !== null) ? price_1.Price.fromPartial(object.price) : undefined;
        message.brokerage = (object.brokerage !== undefined && object.brokerage !== null)
            ? brokerage_1.Brokerage.fromPartial(object.brokerage)
            : undefined;
        message.listingAgent = (object.listingAgent !== undefined && object.listingAgent !== null)
            ? listing_agent_1.ListingAgent.fromPartial(object.listingAgent)
            : undefined;
        message.sold = (object.sold !== undefined && object.sold !== null) ? sold_1.Sold.fromPartial(object.sold) : undefined;
        message.buyerAgent = (object.buyerAgent !== undefined && object.buyerAgent !== null)
            ? buyer_agent_1.BuyerAgent.fromPartial(object.buyerAgent)
            : undefined;
        message.virtualTour = (object.virtualTour !== undefined && object.virtualTour !== null)
            ? virtual_tour_1.VirtualTour.fromPartial(object.virtualTour)
            : undefined;
        message.createdAt = (_r = object.createdAt) !== null && _r !== void 0 ? _r : undefined;
        message.updatedOn = (_s = object.updatedOn) !== null && _s !== void 0 ? _s : undefined;
        message.expiredAt = (_t = object.expiredAt) !== null && _t !== void 0 ? _t : undefined;
        message.soldAt = (_u = object.soldAt) !== null && _u !== void 0 ? _u : undefined;
        message.providerId = (_v = object.providerId) !== null && _v !== void 0 ? _v : 0;
        message.description = (_w = object.description) !== null && _w !== void 0 ? _w : "";
        message.tags = ((_x = object.tags) === null || _x === void 0 ? void 0 : _x.map((e) => tag_1.Tag.fromPartial(e))) || [];
        return message;
    },
};
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new globalThis.Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof globalThis.Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new globalThis.Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
function longToNumber(int64) {
    const num = globalThis.Number(int64.toString());
    if (num > globalThis.Number.MAX_SAFE_INTEGER) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (num < globalThis.Number.MIN_SAFE_INTEGER) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return num;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=property.js.map